import { useQuery } from '@tanstack/react-query';

import { serviceApi } from '~/features';
import { parseDate } from '~/shared';
import { type CampaignModelView } from '~/types';

export const GET_CAMPAIGN_QUERY_KEY = 'GET_CAMPAIGN_QUERY';

export async function getCampaign(id: string, manufacturerId?: number | null) {
  const params = manufacturerId ? { manufacturerId } : undefined;
  return serviceApi.get<CampaignModelView>(`/Campanha?id=${id}`, { params });
}

export function useGetCampaign(id: string, manufacturerId?: number | null) {
  return useQuery({
    queryKey: [GET_CAMPAIGN_QUERY_KEY, id, manufacturerId],
    select: data => {
      const returnData = data?.data;

      const startDate = parseDate(returnData?.startDate);
      const endDate = parseDate(returnData?.endDate);
      const createdAt = parseDate(returnData?.createdAt);
      const updatedAt = parseDate(returnData?.updatedAt);
      const deletedAt = parseDate(returnData?.deletedAt);

      if (returnData?.dayOfWeek) {
        returnData.dayOfWeek = data?.data?.dayOfWeek.map(day => String(day));
      }

      return {
        ...returnData,
        startDate,
        endDate,
        createdAt,
        updatedAt,
        deletedAt,
      };
    },
    queryFn: () => getCampaign(id, manufacturerId),
  });
}
